import { render, staticRenderFns } from "./ProductDesc.vue?vue&type=template&id=f5235530&"
import script from "./ProductDesc.vue?vue&type=script&lang=js&"
export * from "./ProductDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports